import React from "react";
import CustomButton from "./CustomButton";
import { useNavigate } from "react-router-dom";
import { motion, Variants, Easing } from "framer-motion";

const Partner = () => {
  const navigate = useNavigate();

  const handleNavigation = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    navigate("/contact");
  };

  const ease: Easing = [0.6, -0.05, 0.01, 0.99];

  const containerVariants: Variants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease } },
  };

  const itemVariants: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: (i: number) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.2, duration: 0.6, ease },
    }),
  };

  return (
    <motion.div
      className="hidden md:flex w-full bg-[#F3F3F3] my-10 px-8 py-10"
      variants={containerVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.3 }}
    >
      <div className="grid grid-cols-12 gap-8 w-full items-center">
        {/* Title */}
        <motion.h2
          className="col-span-3 font-CrimsonText font-bold text-primaryColor text-3xl lg:text-4xl"
          custom={0}
          variants={itemVariants}
        >
          Partner with us
        </motion.h2>

        {/* Description */}
        <motion.p
          className="col-span-7 font-CrimsonText text-textColor text-base lg:text-lg leading-relaxed text-justify"
          custom={1}
          variants={itemVariants}
        >
          By fostering strong partnerships, we empower ourselves to effectively
          address the ever-changing needs of our valued clients, embracing
          agility and adaptability. Let's engage in a conversation to explore
          how we can further enhance our collective offerings and seize upcoming
          opportunities.
        </motion.p>

        {/* Button */}
        <motion.div
          className="col-span-2 flex justify-end"
          custom={2}
          variants={itemVariants}
        >
          <CustomButton
            title="Discover More"
            onClick={handleNavigation}
            className=" text-[#00964A] border border-primaryColor bg-primaryColor hover:text-white hover:border-white transition-all duration-300 px-6 py-3"
          />
        </motion.div>
      </div>
    </motion.div>
  );
};

export default Partner;
